export default {
  name: 'product-setup',
  routePrefix: 'setup',
  translationKey: 'product-setup-module',
  routeNamePrefix: 'product-setup',
  directRoutesAvailable: true,
}
